import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import { css } from 'aphrodite';
import { EmptyUploadIcon, PageTitle, WarningBanner } from '@sharefiledev/flow-web';
import { getCanDrag, supportsFolderUpload, t, throwIfDirectoryUploadIsNotAvailable } from '../../util';
import { BrowseFiles } from '../BrowseFiles';
import { DragAndDrop } from '../DragAndDrop';
import { FileListInfo } from '../FileListInfo';
import { Html5Uploader } from '../Html5';
import { StyledUploadHint, styles } from './FileUploader.styles';
export var FileUploader = /*#__PURE__*/function (_React$Component) {
  function FileUploader() {
    var _this;
    _classCallCheck(this, FileUploader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FileUploader, [].concat(args));
    _defineProperty(_this, "state", {});
    _defineProperty(_this, "onAddItemsFromComputer", function () {
      for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        items[_key2] = arguments[_key2];
      }
      _this.addItems(items);
    });
    _defineProperty(_this, "removeAll", function () {
      _this.props.removeAll();
      _this.dismissFolderWarning();
    });
    _defineProperty(_this, "browseComputer", function () {
      _this.setState({
        browseComputer: true
      });
    });
    _defineProperty(_this, "addItems", function (items) {
      var itemsToAdd = items.filter(function (item) {
        return _this.isUnique(item) && _this.filterFolder(item);
      });
      if (itemsToAdd.length > 0) {
        _this.props.onAddItems(itemsToAdd);
      }
      _this.setState({
        showFolderWarning: items.some(function (i) {
          return !_this.filterFolder(i);
        })
      });
    });
    _defineProperty(_this, "dismissFolderWarning", function () {
      _this.setState({
        showFolderWarning: false
      });
    });
    return _this;
  }
  _inherits(FileUploader, _React$Component);
  return _createClass(FileUploader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      throwIfDirectoryUploadIsNotAvailable();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/React.createElement("div", {
        className: css(!this.props.files.length && styles.uploadArea)
      }, this.state.showFolderWarning && /*#__PURE__*/React.createElement(WarningBanner, {
        onDismiss: this.dismissFolderWarning
      }, t('citrix-files-ui:upload.prevent_folders')), !this.props.files.length ? /*#__PURE__*/React.createElement(StyledUploadHint, {
        canDragAndDrop: this.canDragAndDrop()
      }, /*#__PURE__*/React.createElement("div", null, this.props.uploadIcon || /*#__PURE__*/React.createElement("div", {
        className: css(styles.browseIcon)
      }, /*#__PURE__*/React.createElement(EmptyUploadIcon, null)), this.canDragAndDrop() && /*#__PURE__*/React.createElement(PageTitle, null, this.props.customDragDropText || t('citrix-files-ui:upload.drag_drop')), this.browseFiles())) : /*#__PURE__*/React.createElement(FileListInfo, {
        fileCount: this.props.files.length,
        removeAll: this.props.allowFilesToBeAdded && this.removeAll
      }, this.props.allowFilesToBeAdded && this.browseFiles()), !this.state.browseComputer && this.canUpload() && /*#__PURE__*/React.createElement(DragAndDrop, {
        onItemsSelected: this.addItems,
        scopedOverlay: this.props.scopedOverlay
      }), /*#__PURE__*/React.createElement(Html5Uploader, {
        showNativeFileBrowser: this.state.browseComputer,
        resetNativeFileBrowserState: function resetNativeFileBrowserState() {
          return _this2.setState({
            browseComputer: false
          });
        },
        onAddItems: this.onAddItemsFromComputer,
        fileOrMimeTypes: this.props.fileOrMimeTypes,
        forceSingleFile: this.props.forceSingleFile
      }));
    }
  }, {
    key: "canUpload",
    value: function canUpload() {
      return this.props.canUpload && this.props.allowFilesToBeAdded;
    }
  }, {
    key: "canDragAndDrop",
    value: function canDragAndDrop() {
      return this.canUpload() && getCanDrag();
    }
  }, {
    key: "browseFiles",
    value: function browseFiles() {
      var hasFiles = this.props.files.length > 0;
      var browseText = hasFiles ? "+ ".concat(t('citrix-files-ui:upload.add_more')) : t('citrix-files-ui:upload.browse_files');
      return /*#__PURE__*/React.createElement(BrowseFiles, {
        attachRight: hasFiles,
        fromComputer: this.canUpload() && this.browseComputer,
        fromShareFile: this.props.browseShareFile,
        additionalOptions: this.props.additionalOptions
      }, browseText);
    }
  }, {
    key: "filterFolder",
    value: function filterFolder(item) {
      if (this.props.allowFolders) {
        return true;
      }
      if (supportsFolderUpload()) {
        return !('getFilesAndDirectories' in item);
      }
      return !this.mightBeFolder(item);
    }
  }, {
    key: "mightBeFolder",
    value: function mightBeFolder(item) {
      return !item.name.includes('.') && !item.size;
    }
  }, {
    key: "isUnique",
    value: function isUnique(itemToAdd) {
      return !this.props.files.find(function (item) {
        return 'uploadRequestParams' in item && item.name === itemToAdd.name;
      });
    }
  }]);
}(React.Component);
_defineProperty(FileUploader, "defaultProps", {
  canUpload: true,
  allowFilesToBeAdded: true,
  allowFolders: true
});